import { DatePipe } from "@angular/common";
import {
  ChangeDetectorRef,
  Component, ElementRef, EventEmitter,
  Input,
  OnChanges, OnInit,
  Output, SimpleChanges, ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { IDatePickerConfig } from "mis-crystal-design-system/datepicker_v2";
import { ISelectedDatesConfig } from "mis-crystal-design-system/daterangepicker_v2/models/drp-config.model";
import * as moment from "moment";
import { parseZone } from "moment";
import { CreateBookingService } from "src/app/bookings/create-booking/create-booking.service";
import {  ISDatePickerConfig} from "mis-crystal-design-system/specificdatepicker";
import { ISSelectedDatesConfig, IRSelectedDatesConfig} from "mis-crystal-design-system/specificdatepicker/models/sdp-config.model";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";

@Component({
  selector: "app-mis-datepicker",
  templateUrl: "./mis-datepicker.component.html",
  styleUrls: ["./mis-datepicker.component.scss"],
})
export class MisDatepickerComponent implements OnInit, OnChanges {
  @Input() singleDateEnabled: boolean;
  @Input() customStyle: string;
  @Input() config: any;
  @Input() inputControl: FormControl;
  @Input() enableBackDatedBooking: boolean;
  @Input() referenceBooking: any;
  @Input() enableDateRangePicker = true;
  @Output() handleApplyFilters = new EventEmitter();
  @Output() selectedDate = new EventEmitter();
  @ViewChild("dateRange", { static: true }) dateRange: ElementRef;
  /** CDS date picker */
  datepickerConfig: Partial<IDatePickerConfig> = {
    minDate: parseZone().format("DD/MM/YYYY"), // Optional
    format: "DD/MM/YYYY", // Taken from moment. https://momentjscom.readthedocs.io/en/latest/moment/04-displaying/01-format/
    maxDate: parseZone().format("DD/MM/YYYY"), // Optional
    timezone: "Asia/Kolkata", // Optional
  };

  selectedDateRange: ISelectedDatesConfig = {
    startDate: null,
    endDate: null,
  };
  selectedDateRange2: ISelectedDatesConfig = {
    startDate: null,
    endDate: null,
  };
  selectedDates: ISSelectedDatesConfig[] = [];
  specificDatepickerConfigs: ISDatePickerConfig = {
    minDate: parseZone().format("DD/MM/YYYY"), // Optional
    format: "DD/MM/YYYY", // Taken from moment. https://momentjscom.readthedocs.io/en/latest/moment/04-displaying/01-format/
    maxDate: '', // Optional
    timezone: "Asia/Kolkata",
  };

selectedDatesRange: IRSelectedDatesConfig = {
      startDate: null,
      endDate: null,
    };
  datesDisabled: string[] = [];
  selectedDate1: string[] = [parseZone().format("DD/MM/YYYY")]; // Today
  dateRangePickerValue = new Date();
  ranges: any;
  specificSelectedDates = "Select";

  constructor(private createBookingService: CreateBookingService, private detechchange: ChangeDetectorRef, private datePipe: DatePipe) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.enableDateRangePicker) {
      if (this.enableBackDatedBooking) {
        this.specificDatepickerConfigs = {
          minDate: '',
          maxDate: parseZone().format("DD/MM/YYYY"),
          format: "DD/MM/YYYY",
          timezone: "Asia/Kolkata",
        };
        this.detechchange.detectChanges();
      }
      else {
        this.specificDatepickerConfigs = {
          maxDate: '',
          minDate: parseZone().format("DD/MM/YYYY"),
          format: "DD/MM/YYYY",
          timezone: "Asia/Kolkata",
        };
        this.detechchange.detectChanges();
      }
//       if(this.referenceBooking)
//       this.selectedDate1=this.referenceBooking.startTime.split(" ").reverse()
// //this.inputControl.value[0][0].format
//       this.selectedDate1=[this.inputControl.value[0].format('DD/MM/YYYY')]
    }
    else if (changes.config && changes.config.currentValue) {
      this.selectedDateRange.startDate = changes.config.currentValue.startDate ? moment(changes.config.currentValue.startDate).format("DD/MM/YYYY") : null;
      this.selectedDateRange.endDate = changes.config.currentValue.endDate ? moment(changes.config.currentValue.endDate).format("DD/MM/YYYY") : null;
      this.datepickerConfig.minDate = changes.config.currentValue.minDate ? moment(changes.config.currentValue.minDate).format("DD/MM/YYYY") : null;
      this.datepickerConfig.maxDate = changes.config.currentValue.maxDate ? moment(changes.config.currentValue.maxDate).format("DD/MM/YYYY") : null;
    }
  }

  // --------------------------new code----------------
  ngOnInit(): void {
    /*   let date = new Date();
      date.setMonth(date.getMonth() - 1);
      let firstDay_ofPrevMon = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay_ofPrevMon = new Date(
        date.getFullYear(),
        date.getMonth() + 1,
        0
      );
      this.ranges = [
        {
          value: [new Date(), new Date()],
          label: "Today",
        },
        {
          value: [
            new Date(new Date().setDate(new Date().getDate() - 1)),
            new Date(),
          ],
          label: "Yesterday",
        },
        {
          value: [
            new Date(new Date().setDate(new Date().getDate() - 7)),
            new Date(),
          ],
          label: "Last 7 days",
        },
        {
          value: [
            new Date(new Date().setDate(new Date().getDate() - 30)),
            new Date(),
          ],
          label: "Last 30 days",
        },
      ]; */

      this.selectedDatesRange.endDate = parseZone().format("DD/MM/YYYY");
      this.selectedDatesRange.startDate = parseZone().format("DD/MM/YYYY");
      // this.selectedDates[0].selectedDate =  parseZone().format("DD/MM/YYYY");

      this.inputControl?.value.forEach((date) => {
        this.selectedDates.push(date[0] ? {selectedDate: date[0].format("DD/MM/YYYY")} : {selectedDate: date.format("DD/MM/YYYY")});
      });
      this.specificSelectedDates = this.selectedDates[0]?.selectedDate;

      this.inputControl?.valueChanges.subscribe(res => {
      if (res instanceof Array) {
        this.selectedDates = [];
        res.forEach((val: any) => {
          this.selectedDates.push({selectedDate: val[0].format("DD/MM/YYYY")});
        });
        this.specificSelectedDates = this.selectedDates.length === 1 ? this.selectedDates[0].selectedDate : "Select Date";
        // this.specificSelectedDates=this.selectedDates[0].selectedDate
      }
    });


  }

  selectDateRange(date) {
    this.selectedDateRange.startDate = this.datePipe.transform(date[0], 'dd/MM/yyyy');
    this.selectedDateRange.endDate = this.datePipe.transform(date[1], 'dd/MM/yyyy');

    if (date !== null && date.length > 0) {
      const rangeDate = {
        endDate: date[1].toLocaleDateString('en-GB'),
        startDate: date[0].toLocaleDateString('en-GB')
      };
      this.selectedDate.emit({ date: rangeDate });
    }
  }
  // onValueChange(value: Date, ele: any): void {
  //   if (value === null) {
  //     return;
  //   } else {
  //     return this.selectedDate.emit({ date: value, ref: ele });
  //   }
  // }

  onDateChange(date: string) {
    this.selectedDates.push({selectedDate: date});
    const newDate = [moment(date, "DD/MM/YYYY")];
    this.inputControl.setValue(newDate);
    this.createBookingService.dateChange.next(date);
  }
  onDateRangeChange(date: string) {
        this.selectedDate1.push(date);
        const newDate = [moment(date, "DD/MM/YYYY")];
        this.inputControl.setValue(newDate);
        this.createBookingService.dateChange.next(date);
  }

  onDateChange2(date: any[]) {

    // this.selectedDate1.push(date)
    const exd = [];

    const sortedDates$ =  of(date).pipe(map(arr => {
      arr.sort((a, b) => {
          const dateA = a.selectedDate.split("/").reverse().join("-");
          const dateB = b.selectedDate.split("/").reverse().join("-");
          return dateA.localeCompare(dateB);
      });
      return arr;
  }));
    sortedDates$.subscribe((sortedDates) => {
  sortedDates.forEach((res) => {
    if (res['selectedDate'] != "")
    {
      const newDate = [moment(res['selectedDate'], "DD/MM/YYYY")];
      exd.push(newDate);
      this.createBookingService.dateChange.next(res['selectedDate']);
    }
  });
});

    this.inputControl.setValue(exd);
  }
  onDateRangeSelect($event) {
    this.selectedDatesRange = $event;

    this.getDatesBetween($event['startDate'], $event['endDate']).subscribe((res) => {
    const exd = [];
    res.forEach((resp) => {

  const newDate = [moment(resp, 'DD/MM/YYYY')];
  exd.push(newDate);
  this.createBookingService.dateChange.next(resp);
    });
    this.inputControl.setValue(exd);
   });
  }

   getDatesBetween(startDateStr: string, endDateStr: string): Observable<any[]> {
    // const startDate = this.parseDate(startDateStr);
    // const endDate = this.parseDate(endDateStr);


   const startDate = moment(startDateStr, "DD/MM/YYYY").toDate();
   const endDate = moment(endDateStr, "DD/MM/YYYY").toDate();
   const dates = [];

   for (const date = startDate; date.getTime() <= endDate.getTime(); date.setDate(date.getDate() + 1)) {
      dates.push(moment(date.getTime()).format("DD/MM/YYYY"));
    }

   return of(dates);
  }

   parseDate(dateStr: string): Date {
    const [day, month, year] = dateStr.split('/').map(Number);
    return new Date(year, month - 1, day);
  }


}
